<template>
    <v-container class='text-left padding-only-left'>
        <!-- <div class="headerPage">
            <span class="titlePage"> {{'Atendimentos' | translate('Atendimentos')}} </span>
        </div> -->
        <div>
            <div id="borderBottomTabs3" class="borderBottomTabs"></div>
            <v-tabs
                v-resize="onResize"
                height="50px"
                class="headerTabs"
                color="black"
                slider-size="4" 
                v-model="tab"
                show-arrows
            >
                <v-tab class="atendimentosTab" @click="changeRouter('/atendimentos_situacoes')">
                    <span>{{labels.situacoes}}</span>
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-container>
</template>

<script>
import translate from '../../../../../src/plugins/translate'

export default {
    name: 'Atendimentos',
    components: {},
    data() {
        return {
            tab: null,
            labels: {
                situacoes: translate('Situações', 'Atendimentos')
            }
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.buildborderTabs()
        },
        changeRouter(route) {
            if(window.location.pathname != route) this.$router.push(route)
        },
        buildborderTabs() {
            var allTabs = document.getElementsByClassName('atendimentosTab')
            var widthBorderBoddom = 0
            allTabs.forEach(function(tab){
                widthBorderBoddom += tab.offsetWidth
            })
            let element = document.getElementById('borderBottomTabs3')
            this.$nextTick(function(){
                element.style.width = `${widthBorderBoddom}px`
            })
        }
    },
    mounted() {
        // this.changeRouter('/atendimentos_situacoes')
        this.onResize()
    },

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.padding-only-left{
    padding: 0 0 0 10px;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
.atendimentosTab > span{
    font-weight: bolder !important;
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    top: 50px;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
}
</style>
